import { useMemo } from "react";
import styled from "styled-components";
import { AuthenticationStatus } from "~/contexts/authn";
import useAuthN from "~/hooks/use-authn";
import RecipeRemixInput from "../recipe-remix-input";
import { getLogger } from "~/utils/logging";

const logger = getLogger("RecipeHelperBar");

interface RecipeHelperBarProps {
  recipeid: string
}

const RecipeHelperBar = (props: RecipeHelperBarProps) => {
  const remix = useMemo(() => {
    return (
      <RemixContainer>
        <RecipeRemixInput
          recipeid={props.recipeid}
        />
      </RemixContainer>
    );
  }, [props.recipeid]);

  return (
    <Container {...props}>
      {remix}
    </Container>
  );
};

const Container = styled.div`
  background: ${(props) => props.theme.colors.onyx};
  display: flex;
  justify-content: center;
  width: 100%;
  height: 4rem;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.02);
  z-index: 101;
  position: fixed;
  bottom: 0;
  align-items: center;
  margin: 0;
  padding: 0;
  border-top: 1px solid #ccc;
`;

const RemixContainer = styled.div`
  width: calc(100vw - 200px);
  min-width: 350px;
  height: calc(100% - 25px);
  max-width: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 10px;
`;

export default RecipeHelperBar;
